// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3judD","large":"styles_large__3Z9ms"};